import env from '@/services/config.js';
export default [
	{
		path: '/albumManage/',
		component: () => import('@/views/home'),
		title: '我的合集 ',
		name: 'album.myAlbum',
		type: 'album',
		class: 'icon-fanhuihoutai',
		meta: {
			crumb: '合集管理',
			title: '合集管理',
			code: 21,
		},
		children: [
			{
				path: 'liveManage/:albumId',
				component: () => import('@/views/album/liveManage'),
				title: '直播管理',
				name: 'album.liveManage',
				ename: 'liveManage/',
				class: 'icon-shipinzhibo',
				meta: {
					// crumb: '直播管理',
					// title: '直播管理',
				},
			},
			{
				path: 'basic/:albumId',
				component: () => import('@/views/album/basic'),
				title: '合集设置',
				name: 'album.basic',
				ename: 'basic/',
				class: 'icon-zhiboshezhi-',
				meta: {
					// crumb: '基本设置',
					// title: '基本设置',
				},
			},
			{
				path: 'basic/:albumId/exam',
				component: () => import('@/views/album/exam.vue'),
				title: '学员设置',
				name: 'album.exam',
				ename: 'exam/',
				class: 'icon-zhiboshezhi-',
				meta: {
					// crumb: '学员设置',
					// title: '学员设置',
					showExamIds:
						env.key === 'v1'
							? [6624, '6624', 6625, '6625', 6626, '6626']
							: [936, '936', '1010', 1010, '1011', 1011, '1012', 1012, '1018', 1018, '1019', 1019],
				},
				children: [
					{
						path: 'examDetail',
						name: 'album.examDetail',
						component: () => import('@/views/album/exam/examDetail'),
						hidden: true,
						meta: {
							parentName: 'album.exam',
							// crumb: '学员设置',
							// title: '学员设置',
						},
					},
				],
			},
			// {
			// 	path: 'theme/:albumId',
			// 	component: () => import('@/views/album/theme'),
			// 	title: '主题设置',
			// 	name: 'album.theme',
			// 	ename: 'theme/',
			// 	class: 'icon-pintu',
			// },
			{
				path: 'watch/:albumId',
				component: () => import('@/views/album/watch'),
				title: '观看设置',
				name: 'album.watch',
				ename: 'watch/',
				class: 'icon-shouquanguanli-',
				meta: {
					// crumb: '观看设置',
					// title: '观看设置',
					hideExamIds:
						env.key === 'v1'
							? [6624, '6624', 6625, '6625', 6626, '6626']
							: [936, '936', '1010', 1010, '1011', 1011, '1012', 1012, '1018', 1018, '1019', 1019],
				},
				children: [
					{
						path: 'surveyRecords',
						name: 'album.surveyRecords',
						component: () => import('@/views/user/liveset/see/surveyRecords'),
						hidden: true,
						meta: {
							parentName: 'album.watch',
							// crumb: '观看设置',
							// title: '观看设置',
						},
					},
					{
						path: 'whiteList',
						name: 'album.whiteList',
						component: () => import('@/views/user/liveset/see/whiteListAlbum.vue'),
						hidden: true,
						meta: {
							parentName: 'album.watch',
							// crumb: '观看设置',
							// title: '观看设置',
						},
					},
					{
						path: 'whitePhone',
						name: 'album.whitePhone',
						component: () => import('@/views/user/liveset/see/whitePhone'),
						hidden: true,
						meta: {
							parentName: 'album.watch',
						},
					},
				],
			},
			{
				path: 'share/:albumId',
				component: () => import('@/views/album/share'),
				title: '分享设置',
				name: 'album.share',
				ename: 'share/',
				class: 'icon-dingzhifenxiang-',
				meta: {
					// crumb: '分享设置',
					// title: '分享设置',
				},
			},
			// {
			// 	path: 'statistics/:albumId',
			// 	component: () => import('@/views/album/statistics'),
			// 	title: '数据展示',
			// 	name: 'album.statistics',
			// 	ename: 'statistics/',
			// 	class: 'icon-shujutongji-',
			// },
			{
				path: 'payList/:albumId',
				component: () => import('@/views/album/payList'),
				hidden: true,
				name: 'album.payList',
				ename: 'payList/',
				meta: {
					parentName: 'album.watch',
					// crumb: '付费列表',
					// title: '付费列表',
				},
			},
		],
	},
];
